<template>
  <div class="live">    
    <main-content
      :background-image="backgroundImage"
      right-sidebar="true"
    >
      <div class="live__markers">
        <transition-group name="fast-fade">
          <router-link
            v-for="(livingOption, i) in livingOptions"
            :key="livingOption._id"          
            :to="`/live/${livingOption._id}`"
          >
            <tag-reference
              :pos="{ x: livingOption.marker.x, y: livingOption.marker.y }"
              :label="i + 1"
            />
          </router-link>
        </transition-group>
        <!-- <availability-marker
          v-for="livingOption in livingOptions"
          v-show="livingOption.matchedPropertiesCount"
          :key="livingOption._id"
          :x="livingOption.marker.x"
          :y="livingOption.marker.y"
          :filtered="!livingOption.matchedPropertiesCount"
          :property-count="livingOption.matchedPropertiesCount"
          @click.native="activeLivingOption = livingOption"
        /> -->

      </div>
      <transition name="fade-in-up">
        <div v-if="activeLivingOption" class="live__option-info">
          <div class="live__option-info-heading">{{ activeLivingOption.label }}</div>
          <img :src="$store.state.assetsPath + activeLivingOption.logo" />
          <button @click="$router.push(`/live/${activeLivingOption._id}`)"><fa icon="home"/> View Living Options</button>
        </div>
      </transition>
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="$store.state.config.liveHereSidebarMinimap"
      :heading="$store.state.config.liveHereHeading"
      :description="$store.state.config.liveHereDescription"
      :navigation-items="navigationItems"
    > 
      <!-- <div slot="top-slot">
        <property-filter/>
      </div> -->
      <template slot="bottom-slot">
        <!-- <router-link tag="button" class="right-sidebar__back" to="/live"><fa icon="chevron-left"/>Back</router-link>
        <div class="right-sidebar__search"></div> -->
        <!-- <button class="right-sidebar__search"><fa icon="search"/>Search</button> -->
      </template>
    </right-sidebar>
  </div>
</template>
<script>
import AvailabilityMarker from '@/components/AvailabilityMarker'
import MainContent from '@/components/MainContent'
import PropertyFilter from '@/components/PropertyFilter'
import TagReference from '@/components/TagReference'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'live',
  components: { AvailabilityMarker, MainContent, PropertyFilter, TagReference, RightSidebar },

  data () {
    return {
      activeLivingOption: null
    }
  },

  computed: {
    ...mapState({
      backgroundImage: state => state.config.liveHereBackground,
      properties: state => state.property.properties,
      propertyModels: state => state.property.propertyModels,
    }),

    livingOptions () {
      let livingOptions = []
      // We want to show a Living Option even when it doesnt have any subsections/properties associated to it, this allows us to show all living options when there is no property type filter applied (masterplan button)
      // TODO: remove when all living options have properties associated to them and this becomes redundant
      if (this.$store.state.property.inputType === null) {
        livingOptions = this.$store.getters['property/livingOptions']
      } else {
        livingOptions = _.filter(this.$store.getters['property/livingOptions'], livingOption => {
          return livingOption.matchedPropertiesCount
        })
      }
      return _.sortBy(livingOptions, livingOption => {
        return livingOption.marker.x
      })
    },

    navigationItems () {
      let navigationItems = []
      // Similar to above, but display all navigation items if masterplan selected
      if (this.$store.state.property.inputType === null) {
        this.livingOptions.forEach((livingOption, i) => {
          navigationItems.push({
            label: `${i + 1}. ${livingOption.label}`,
            to: `/live/${livingOption._id}`,
            key: `${this.$store.state.property.inputType}-${livingOption._id}`
          })
        })
      } else {
        this.livingOptions.forEach((livingOption, i) => {
          if (!livingOption.filter) {
            navigationItems.push({
              label: `${i + 1}. ${livingOption.label}`,
              to: `/live/${livingOption._id}`,
              key: `${this.$store.state.property.inputType}-${livingOption._id}`
            })
          }
        })
      }
      return navigationItems
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.live {
  &__background {
    height: 100rem;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 152rem;
  }

  &__markers {
    height: 98rem;
    left: 0;
    position: absolute;
    top: 0;
    width: 152rem;
  }

  &__option-info {
    background: rgba($black, 0.5);
    padding: 1rem;
    position: absolute;
    top: 20rem;
    left: 80rem;
    text-align: center;

    img {
      display: block;
      max-width: 100px;
      margin: 1rem auto;
    }

    &-heading {
      font-size: 3rem;
      text-align: center;
    }
  }
}
</style>
